import { Logger, Source } from '@conteg/logging';
import env from 'utils/env/env';

export const logger = new Logger({
  serviceUrl: env.VITE_LOGGING_URL,
  source: Source.Maintenance,
  token: '12345678901',
  enabled: env.NODE_ENV !== 'development',
});
